<template>
  <div>
    <div class="card search">
      <el-form ref="searchForm" size="small" :inline="true" :model="filterForm">
        <el-form-item label="委托项目：" prop="projectCode">
          <el-input
            v-model.trim="filterForm.projectCode"
            class="project-input"
            placeholder="输入项目名称、项目编号"
          />
        </el-form-item>
        <el-form-item label="项目类型：" prop="projectType">
          <el-select v-model="filterForm.projectType">
            <el-option label="全部" value="" />
            <el-option
              v-for="item in projectTypeDict.array"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>
        <el-form-item :label="statusInfo.label" prop="acceptStatus">
          <el-select v-model="filterForm.acceptStatus">
            <el-option label="全部" value="" />
            <el-option
              v-for="item in statusInfo.dictArr"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="委托时间：">
          <jczh-date-picker
            v-model="entrustTimeRange"
            type="datetimeRange"
            :default-time="['00:00:00', '23:59:59']"
          />
        </el-form-item>
        <el-form-item class="operate">
          <div class="flex-align">
            <el-button type="primary" @click="handleSearch">
              查询
            </el-button>
            <el-button @click="handleReset">
              重置
            </el-button>
          </div>
        </el-form-item>
      </el-form>
    </div>

    <div class="card no-padding">
      <slot name="button"></slot>

      <el-table
        border
        :data="listData"
        class="m-t-16"
        size="medium"
        highlight-current-row
        header-row-class-name="table-header"
      >
        <el-table-column
          label="序号"
          prop="index"
          align="center"
          type="index"
          width="60"
        />
        <el-table-column
          label="项目名称"
          prop="projectName"
          align="center"
          min-width="130"
          show-overflow-tooltip
        >
          <template slot-scope="{ row }">
            <span>{{ row.projectName || ' - ' }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="项目编号"
          prop="projectCode"
          align="center"
          min-width="100"
          show-overflow-tooltip
        >
          <template slot-scope="{ row }">
            <span>{{ row.projectCode || ' - ' }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="项目类型"
          prop="projectType"
          align="center"
          min-width="130"
        >
          <template slot-scope="{ row }">
            <span>
              {{ projectTypeDict.translate(row.projectType).label || ' - ' }}
            </span>
          </template>
        </el-table-column>
        <el-table-column
          label="项目概算（元）"
          prop="budget"
          align="right"
          header-align="center"
          min-width="130"
        >
          <template slot-scope="{ row }">
            <span> {{ row.budget | projectEstimateFilter }} </span>
            <money-in-cn
              v-if="row.budget"
              :money="row.budget"
              :show-prefix="false"
            />
          </template>
        </el-table-column>
        <el-table-column
          label="委托状态"
          prop="acceptStatus"
          align="center"
          min-width="100"
        >
          <template slot-scope="{ row }">
            <!-- <el-tag
              v-if="statusDict.translate(row.acceptStatus)"
              size="small"
              :type="statusDict.translate(row.acceptStatus).type"
            >
              {{ statusDict.translate(row.acceptStatus).label }}
            </el-tag> -->
            <status-tag
              v-if="statusDict.translate(row.acceptStatus)"
              :type="statusDict.translate(row.acceptStatus).type"
              :label="statusDict.translate(row.acceptStatus).label"
              :tag-style="{ display: 'block' }"
              size="small"
            />
            <span v-else> - </span>
          </template>
        </el-table-column>
        <el-table-column
          label="委托时间"
          prop="entrustTime"
          align="center"
          min-width="180"
        >
          <template slot-scope="{ row }">
            <div>{{ row.entrustTime || ' - ' }}</div>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" width="200" fixed="right">
          <template slot-scope="{ row }">
            <slot name="operator" :data="row"></slot>
          </template>
        </el-table-column>
      </el-table>

      <pagination
        v-show="total > 0"
        :total="total"
        :page.sync="page"
        :limit.sync="size"
      />
    </div>
  </div>
</template>

<script>
import StatusTag from '@/components/common/StatusTag.vue'
import Pagination from '@/components/common/Pagination'
import MoneyInCn from '@/components/common/MoneyInCn'

import listFilterMixin from '@/mixins/list-filter-mixin'

import {
  bidEntrustStatusDict,
  bidAcceptStatusDict
} from '@/dictionary/project/bid'
import { projectTypeDict } from '@/dictionary/project/common'
import { workbenchServiceDict } from '@/dictionary/system'

import { fetchEntrustListApi } from '@/api/procure/entrust'

import { strToThousands } from '@/utils/utils'
import { mapState } from 'vuex'
export default {
  components: {
    Pagination,
    StatusTag,
    MoneyInCn
  },

  filters: {
    // 金额过滤
    projectEstimateFilter(estimate) {
      return estimate ? strToThousands(estimate) : ' - '
    }
  },

  mixins: [listFilterMixin],

  data() {
    return {
      bidEntrustStatusDict: bidEntrustStatusDict, // 委托状态字典
      bidAcceptStatusDict: bidAcceptStatusDict, // 代理委托状态字典
      projectTypeDict: projectTypeDict, // 项目类型字典

      filterForm: {
        projectCode: '', // 项目名称或项目编号
        projectType: '', // 项目类型
        entrustStartTime: '', // 委托查询开始时间
        entrustEndTime: '', // 委托查询结束时间
        acceptStatus: '', // 委托状态
        agentCompanyId: '' // 代理机构id
      },
      total: 0,
      // 列表数据
      listData: []
    }
  },

  computed: {
    // 用户平台信息
    ...mapState('router', ['currentWorkbench']),
    ...mapState('company', ['companyId']),

    statusInfo() {
      if (this.currentWorkbench === workbenchServiceDict.AGENCY.value) {
        return {
          label: '代理委托状态：',
          labelWidth: '120px',
          dictArr: this.bidAcceptStatusDict.array
        }
      } else {
        return {
          label: '委托状态：',
          labelWidth: '90px',
          dictArr: this.bidEntrustStatusDict.array
        }
      }
    },

    statusDict() {
      return this.currentWorkbench === workbenchServiceDict.PURCHASER.value
        ? bidEntrustStatusDict
        : bidAcceptStatusDict
    },

    entrustTimeRange: {
      get() {
        return [
          this.filterForm.entrustStartTime,
          this.filterForm.entrustEndTime
        ]
      },
      set(val) {
        if (val?.length) {
          this.filterForm.entrustStartTime = val[0]
          this.filterForm.entrustEndTime = val[1]
        }
      }
    }
  },

  created() {
    this.filterForm.acceptStatus = this.$route.query?.orderStatus ?? ''
    this.filterForm.identityCode = workbenchServiceDict.translate(
      this.currentWorkbench
    )?.platformAlias
  },

  methods: {
    budgetFilter(estimate) {
      return estimate ? `${strToThousands(estimate)} (元)` : ' - '
    },

    /**
     * @description: 表单校验
     * @param {*}
     * @return {*}
     */
    async formValid() {
      try {
        if (!this.$refs.searchForm) return true
        await this.$refs.searchForm.validate()
        return true
      } catch (e) {
        return false
      }
    },

    // 获取列表数据
    async getList() {
      this.epitaxy()
      const valid = await this.formValid()
      if (!valid) return
      const requestParams = {
        page: this.page,
        size: this.size,
        ...this.filterForm
      }

      try {
        const _data = await fetchEntrustListApi(requestParams)
        this.listData = _data.data.records || []
        this.total = _data.data.total || 0
      } catch (err) {
        this.$message.error(err.message || '获取委托列表失败')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.create-button {
  margin: 16px 16px 0;
}
</style>
